import classNames from 'classnames'
import { EmptyFunction } from '../utils/functions'

export const FilterOptionsTitle = ({
  title = '',
  isSelected = false,
  selectedCount = 0,
  onClick = EmptyFunction
}) => {
  return (
    <div
      className={classNames(
        'flex w-full cursor-pointer border-[0.5px] border-b-none border-solid border-[#404040] border-opacity-10 pt-15 pb-14 pl-16 text-base leading-[21.11px] text-[#17191C]',
        isSelected && 'bg-secondary pt-18 font-bold'
      )}
      {...{ onClick }}
    >
      {title} {selectedCount != 0 && !!selectedCount && ' ' + `(${selectedCount})`}
    </div>
  )
}
